module.exports = "https://static.energy5.com/_next/static/images/slide1-f5eb396235e75ffee49c7ec99f43da0d.png";